import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import React from 'react';
import TextBlock from 'libs/wordpress/content/cmsBlocks/TextBlock';

const TextLayout = ({ ...rest }) => (
    <MaxWidthWrapper includeContentMargins mb={['48px', null, null, '64px']}>
        <TextBlock {...rest} />
    </MaxWidthWrapper>
);

export default TextLayout;
